import DataAccess from './constants';
import API from './API'

const path = 'giftcardholds'
let api = new API(DataAccess.apiUrl, DataAccess.userName, DataAccess.password);

export const postGiftCardHold = (tourhold) => {
    return api.postData(path, tourhold);
}

export const deleteGiftCardHold = (params) => {
    return api.deleteData(path + params, {});
}